// @flow
export { default } from './RegisterTemplate';



// WEBPACK FOOTER //
// ./src/components/register/RegisterTemplate/index.js